<template>
    <div style="padding-bottom: 100px;">
      <el-button type="primary" @click="$router.go(-1)" style="float: left;">返回</el-button>
      <h2 v-if="$route.query.type == 'gross'">调整粗动作方案</h2>
      <h2 v-if="$route.query.type == 'fine'">调整细动作方案</h2>
      <h2 v-if="$route.query.type == 'level'">调整训练级别</h2>
      <el-table class="custom-table" :data="articles" border stripe @row-click="editArticle"
       :show-header="false"
       :cell-style="{ borderBottom: '1px solid #ff0000' }"
       >
        <el-table-column>
          <template slot-scope="{ row }">
            <div class="article-item" v-if="$route.query.type != 'level'">
              <h3>训练类型：<span v-if="$route.query.type == 'gross'">{{ row.title }}</span><span v-if="$route.query.type == 'fine'">{{ row.subtitle }}</span></h3>
              <h4 v-if="$route.query.type == 'gross'">选中部位：<span>{{ row.subtitle }}</span></h4>
              <h4 v-if="$route.query.type == 'fine'">延伸次数：<span>{{ row.times }}</span></h4>
              <h4>训练内容：</h4><p>{{ row.summary }}</p>
            </div>
            <div class="article-item" v-if="$route.query.type == 'level'">
              <h3>{{ row.title }}：<span>{{ row.subtitle }}</span></h3>
            </div>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 文章编辑对话框 -->
      <edit-article-dialog
        :visible.sync="dialogVisible"
        :articleData="selectedArticle"
        @save="updateArticle"
      />
    </div>
  </template>
  
  <script>
  import EditArticleDialog from "../components/EditPlanDialog.vue"; // 确保路径正确
  import { getEvaluaRecordById, saveEvaluaData} from '@/api/app'
  export default {
    components: { EditArticleDialog },
    data() {
      return {
        articles: [],
        dialogVisible: false,
        selectedArticle: null, 
        form: {},       
        /* grossTypeData:[
          { id: 150, title: "跑", value: "1", type_id: 1013, type_value: "gross_train_type", sort: 1, subtitle: "", summary: "" },
          { id: 151, title: "爬", value: "2", type_id: 1013, type_value: "gross_train_type", sort: 2, subtitle: "", summary: "" },
          { id: 152, title: "跳", value: "3", type_id: 1013, type_value: "gross_train_type", sort: 3, subtitle: "", summary: "" },
          { id: 153, title: "滚", value: "4", type_id: 1013, type_value: "gross_train_type", sort: 4, subtitle: "", summary: "" },
        ], */
       /*  fineTypeData:[
          { id: 1, title: "布类", subtitle: "布类",times:2, summary: "(1)把布,用手抽出30-100条线,再用布把矿泉水瓶包起来,粘好" }
        ], */
        levelData: [
        { id: 1, title: "粗动作结果", subtitle: "轻度", summary: "" },
        { id: 2, title: "细动作结果", subtitle: "中度", summary: "" }
        ],
      };
    },
    created() {
      // console.log(this.$route.query.type)
      this.initArticles()
    },
    mounted () {
      //this.fetchData()
    },
    methods: {
      // 初始化文章列表
      async initArticles() {
        //this.articles = this.$store.state.articles; // 从 Vuex 获取文章列表
        const params = {
          eid: this.$route.query.eid
        }
        const fData = await getEvaluaRecordById(params)
        // console.log('students====', fData)
        this.form = fData
        //return
        if(this.$route.query.type == 'gross'){
          this.articles = fData.grossPlan //this.grossTypeData
        }
        if(this.$route.query.type == 'fine'){
          this.articles = fData.finePlan //this.fineTypeData
        }
        if(this.$route.query.type == 'level'){
          this.levelData[0].subtitle = fData.gross_motor_state
          this.levelData[1].subtitle = fData.fine_motor_state
          this.articles = this.levelData
        }
      },      
      async saveData () {
        // 保存数据的逻辑
        // console.log(this.check)
        // console.log(this.form)
        const params = {
          evalua_id: this.form.evalua_id,
          form: JSON.stringify(this.form)
        }
        const fData = await saveEvaluaData(params)
        this.$message.success(`保存成功！`)        
      },
      // 处理点击文章行，弹出编辑框
      editArticle(row) {
        this.selectedArticle = { ...row }; // 深拷贝防止直接修改原数据
        this.selectedArticle['selectData'] = this.selectedArticle.subtitle ? this.selectedArticle.subtitle.split(' ') : []
        this.dialogVisible = true;
      },
      // 更新文章信息
      updateArticle(updatedArticle) {
        const index = this.articles.findIndex((a) => a.id === updatedArticle.id);
        if (index !== -1) {
          this.$set(this.articles, index, updatedArticle);
        }
        this.dialogVisible = false;
        if(this.$route.query.type == 'gross'){
          this.form.grossPlan = this.articles
        }
        if(this.$route.query.type == 'fine'){
          this.form.finePlan = this.articles
        }
        if(this.$route.query.type == 'level'){
          this.form.gross_motor_state = this.articles[0].subtitle
          this.form.fine_motor_state = this.articles[1].subtitle
        }        
        //console.log('updatedArticle==this.articles==', this.form)
        this.saveData()
      },
    },
  };
  </script>
  
  <style scoped>
  h2 {
    margin-bottom: 8px;
    text-align: center;
  }
  
  .article-item {
    padding: 0px;
    display: flex;
    flex-direction: column;
  }
  
  .article-item h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    padding: 0px;
    margin-bottom: 5px;
  }
  
  .article-item h4 {
    font-size: 16px;
    color: #666;
    margin: 0;
    padding: 0px;
    margin-bottom: 5px;
  }
  
  .article-item p {
    font-size: 18px;
    color: #333;
    padding-left: 75px;
  }

  .article-item h3 span,.article-item h4 span{
    color: #000000;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/Setplan.vue